import * as React from "react";
import { Component } from "react";
import Copy from "../icons/Copy";
import Ok from "../icons/Ok";
import Button from "./Button";

interface CopyToClipboardButtonProps {
  label: string;
  textToCopy: string;
}

interface CopyToClipboardButtonState {
  hasCopied: boolean;
}

class CopyToClipboardButton extends Component<
  CopyToClipboardButtonProps,
  CopyToClipboardButtonState
> {
  constructor(props: CopyToClipboardButtonProps) {
    super(props);
    this.state = {
      hasCopied: false,
    };
  }

  timeout: ReturnType<typeof setTimeout>;

  handleClick = () => {
    clearTimeout(this.timeout);
    this.setState({
      hasCopied: true,
    });

    navigator.clipboard.writeText(this.props.textToCopy);

    this.timeout = setTimeout(() => {
      this.setState({
        hasCopied: false,
      });
    }, 3000);
  };

  render() {
    if (this.state.hasCopied) {
      return (
        <Button
          icon={<Ok />}
          label="Copied to clipboard"
          onClick={this.handleClick}
          size="big"
          type="success"
        />
      );
    }

    return (
      <Button
        icon={<Copy />}
        label={this.props.label}
        onClick={this.handleClick}
        size="big"
        type="secondary"
      />
    );
  }
}

export default CopyToClipboardButton;
